import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EmberTicker from '@/pages/home/components/EmberTicker';

const BLUE_GREY = '#5b8ab5';

export default function ProjectsNav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleNav = (path: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    setMenuOpen(false);
    navigate(path);
    setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 50);
  };

  return (
    <>
      {/* TOP TICKER BAR — Ember Gradient */}
      <EmberTicker />

      {/* MAIN NAV */}
      <nav className="border-b border-white/10" style={{ background: '#0d0d0f', marginTop: '20px' }}>
        <div className="px-4 md:px-8 py-4 flex items-center justify-between">
          <a href="/" onClick={handleNav('/')} className="cursor-pointer flex items-center">
            <img
              src="https://storage.readdy-site.link/project_files/436b8b39-7177-4764-8ecd-b07483d3e043/03ebce5f-d5da-4799-81c4-50550e752dac_ANNA-LOGO_INITIALS-WHITE.png?v=2a513169e4cb9aa0ba1be00f988dd533"
              alt="Anna Schriver"
              className="h-[57px] w-auto object-contain"
            />
          </a>
          <div className="hidden md:flex items-center gap-10">
            <a href="/" onClick={handleNav('/')} className="text-white/70 text-sm font-semibold tracking-widest uppercase hover:text-white transition-colors whitespace-nowrap cursor-pointer">Welcome</a>
            <a href="/projects" onClick={handleNav('/projects')} className="text-sm font-semibold tracking-widest uppercase whitespace-nowrap cursor-pointer" style={{ color: BLUE_GREY }}>Projects</a>
            <a href="/about" onClick={handleNav('/about')} className="text-white/70 text-sm font-semibold tracking-widest uppercase hover:text-white transition-colors whitespace-nowrap cursor-pointer">About Me</a>
            <a
              href="/contact"
              onClick={handleNav('/contact')}
              className="text-white px-6 py-2 text-sm font-bold tracking-widest uppercase whitespace-nowrap cursor-pointer rounded-md btn-glow"
              style={{ background: BLUE_GREY }}
            >
              GET IN TOUCH
            </a>
          </div>
          <button className="md:hidden text-white cursor-pointer" onClick={() => setMenuOpen(!menuOpen)}>
            <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
        <div className="h-px bg-white/10 w-full"></div>
        {menuOpen && (
          <div className="md:hidden px-4 py-6 flex flex-col gap-4" style={{ background: '#0d0d0f' }}>
            <a href="/" onClick={handleNav('/')} className="text-white text-sm font-semibold tracking-widest uppercase">Welcome</a>
            <a href="/projects" onClick={handleNav('/projects')} className="text-sm font-semibold tracking-widest uppercase" style={{ color: BLUE_GREY }}>Projects</a>
            <a href="/about" onClick={handleNav('/about')} className="text-white text-sm font-semibold tracking-widest uppercase">About Me</a>
            <a href="/contact" onClick={handleNav('/contact')} className="text-white text-sm font-semibold tracking-widest uppercase">Get in Touch</a>
          </div>
        )}
      </nav>
    </>
  );
}
